import ScheduleFiltersTags from '../../../Filters/FiltersTags';
export default ScheduleFiltersTags;
